import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { PrivateEquityIssuanceCreateManuallyPayload } from '../models/privateEquityIssuance';

export const onCheckPrivateEquityLimit = async (total_new_common_shares: number) => {
	try {
		const response = await axios.post('dashboard/actions/raise-capital/check-authorized-capital-limit', { total_new_common_shares });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetOwnersRegistryTemplate = async () => {
	try {
		const response = await axios.get<JsonResponse<{ excel_file_url: string }>>('dashboard/actions/raise-capital/owners-registry-template');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreatePrivateEquityIssuanceManually = async (payload: PrivateEquityIssuanceCreateManuallyPayload) => {
	try {
		const response = await axios.post('dashboard/actions/raise-capital/private-equity-issuance', payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreatePrivateEquityIssuanceWithFile = async (payload: FormData) => {
	try {
		const response = await axios.post('dashboard/actions/raise-capital/private-equity-issuance', payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdatePrivateEquityIssuanceManually = async (id: string, payload: PrivateEquityIssuanceCreateManuallyPayload) => {
	try {
		const response = await axios.put(`dashboard/actions/raise-capital/private-equity-issuance/${id}`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdatePrivateEquityIssuanceWithFile = async (id: string, payload: FormData) => {
	try {
		const response = await axios.post(`dashboard/actions/raise-capital/private-equity-issuance/${id}`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
